<template>
  <div>
    <div class="container">
      <div style="width: 1000px; margin-top: 40px">
        <p
          style="font-size: 12px; color: #333333; line-height: 2; margin-top: 0px; margin-bottom: 0px; font-family: mp-quote, -apple-system-font, BlinkMacSystemFont, 'Helvetica Neue', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI', 'Microsoft YaHei', Arial, sans-serif;">
          <span style="font-size: 16px;"><strong><strong>德彩</strong></strong><strong><strong> |
              </strong></strong><strong><strong>创造无限可能，造景大师齐聚德彩总部，上演巅峰对决！</strong></strong></span></p>
        <p
          style="font-size: 12px; color: #333333; line-height: 2; margin-top: 0px; margin-bottom: 0px; font-family: mp-quote, -apple-system-font, BlinkMacSystemFont, 'Helvetica Neue', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI', 'Microsoft YaHei', Arial, sans-serif;">
          <span style="font-size: 16px;">全球首届 Tetra Aquatics Festival 在德国总部成功举办，汇聚欧洲顶级水族造景KOL 竞技交流，共创水族艺术新高度。</span></p>
        <p
          style="font-size: 12px; color: #333333; line-height: 2; margin-top: 0px; margin-bottom: 0px; font-family: mp-quote, -apple-system-font, BlinkMacSystemFont, 'Helvetica Neue', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI', 'Microsoft YaHei', Arial, sans-serif;">
          &nbsp;</p>
        <p
          style="font-size: 12px; color: #333333; line-height: 2; margin-top: 0px; margin-bottom: 0px; font-family: mp-quote, -apple-system-font, BlinkMacSystemFont, 'Helvetica Neue', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI', 'Microsoft YaHei', Arial, sans-serif;">
          <span style="font-size: 16px;"><strong><strong>探索水族无限可能，</strong><strong>Tetra Aquatics Festival
              </strong><strong>引领造景新潮流</strong></strong></span></p>
        <p
          style="font-size: 12px; color: #333333; line-height: 2; margin-top: 0px; margin-bottom: 0px; font-family: mp-quote, -apple-system-font, BlinkMacSystemFont, 'Helvetica Neue', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI', 'Microsoft YaHei', Arial, sans-serif;">
          <span style="font-size: 16px;">全球首届 Tetra Aquatics Festival 在德国总部盛大举行，汇聚16
            位欧洲顶级水族造景KOL，呈现高水准的造景竞技与跨国交流。经过激烈角逐，西班牙团队凭借出色作品夺冠，Tetra也借此活动开启水族造景的新篇章，未来将推出更多创新产品，助力爱好者探索无限可能。</span></p>
        <p class="before-image"
          style="font-size: 12px; color: #333333; line-height: 2; margin-top: 0px; margin-bottom: 0px; font-family: mp-quote, -apple-system-font, BlinkMacSystemFont, 'Helvetica Neue', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI', 'Microsoft YaHei', Arial, sans-serif;">
          &nbsp;</p>
        <section>
          <section style="margin: 10px auto;">
            <section class="" style="border: 1px solid #28b2fe; padding: 13px; box-sizing: border-box;">
              <section class="" style="width: 100%; max-width: 100% !important; box-sizing: border-box;"><span
                  style="font-size: 16px;"><img
                    style="width: 100%; display: block; vertical-align: baseline; box-sizing: border-box; max-width: 100% !important;"
                    draggable="false"
                    src="https://xiaomeng-card-local.oss-cn-shenzhen.aliyuncs.com/local/0/0/1744878015266104.png"
                    data-ratio="1" data-w="1" /></span></section>
            </section>
            <section
              style="width: 100%; height: 4px; background-color: #fea6a6; max-width: 100% !important; box-sizing: border-box;">
            </section>
            <section class="assistant"
              style="width: 60px; margin-top: -40px; margin-left: auto; margin-right: 13px; box-sizing: border-box; transform: rotateZ(0deg); -webkit-transform: rotateZ(0deg); -moz-transform: rotateZ(0deg); -o-transform: rotateZ(0deg);">
              <span style="font-size: 16px;"><img class="assistant"
                  style="width: 100%; display: block; vertical-align: baseline; box-sizing: border-box; max-width: 100% !important;"
                  draggable="false"
                  src="https://bcn.135editor.com/files/images/editor_styles/c81f424140309e4ed598fee38f0b0816.gif"
                  data-ratio="0.5735567970204841" data-w="537" /></span></section>
          </section>
        </section>

        <!-- 视频一 -->
        <div style="text-align: center;margin: 40px 0;">
          <iframe width="800" height="480" src="https://xiaomeng-card-prod.oss-cn-shenzhen.aliyuncs.com/prod/0/0/174488063322743.mp4" frameborder="0"
            allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen>
          </iframe>
        </div>

        <p
          style="font-size: 12px; color: #333333; line-height: 2; margin-top: 0px; margin-bottom: 0px; font-family: mp-quote, -apple-system-font, BlinkMacSystemFont, 'Helvetica Neue', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI', 'Microsoft YaHei', Arial, sans-serif;">
          <span
            style="font-size: 16px;">如何让水族造景焕发新生机，为市场注入新活力，并吸引更多人加入这一迷人的爱好？Tetra的市场与创新团队在过去几个月中不断思考这个问题，并最终找到了答案&mdash;&mdash;全球首届
            <strong><strong>Tetra Aquatics Festival</strong></strong>。</span></p>
        <p
          style="font-size: 12px; color: #333333; line-height: 2; margin-top: 0px; margin-bottom: 0px; font-family: mp-quote, -apple-system-font, BlinkMacSystemFont, 'Helvetica Neue', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI', 'Microsoft YaHei', Arial, sans-serif;">
          <span style="font-size: 16px;">这场盛会汇聚了来自九个欧洲国家的16 位水族造景 KOL，在 Tetra
            德国总部共度了一个难忘的周末。无数精彩的照片与视频、跨越国界的专业交流、无与伦比的团队精神&mdash;&mdash;这些都是 Tetra Aquatics Festival
            的关键词。但这次活动的亮点远不止于此。</span></p>
        <section>
          <section style="margin: 10px auto;">
            <section class="" style="border: 1px solid #28b2fe; padding: 13px; box-sizing: border-box;">
              <section class="" style="width: 100%; max-width: 100% !important; box-sizing: border-box;"><span
                  style="font-size: 16px;"><img
                    style="width: 100%; display: block; vertical-align: baseline; box-sizing: border-box; max-width: 100% !important;"
                    draggable="false"
                    src="https://xiaomeng-card-local.oss-cn-shenzhen.aliyuncs.com/local/0/0/1744878072619123.png"
                    data-ratio="1" data-w="1" /></span></section>
            </section>
            <section
              style="width: 100%; height: 4px; background-color: #fea6a6; max-width: 100% !important; box-sizing: border-box;">
            </section>
            <section class="assistant"
              style="width: 60px; margin-top: -40px; margin-left: auto; margin-right: 13px; box-sizing: border-box; transform: rotateZ(0deg); -webkit-transform: rotateZ(0deg); -moz-transform: rotateZ(0deg); -o-transform: rotateZ(0deg);">
              <span style="font-size: 16px;"><img class="assistant"
                  style="width: 100%; display: block; vertical-align: baseline; box-sizing: border-box; max-width: 100% !important;"
                  draggable="false"
                  src="https://bcn.135editor.com/files/images/editor_styles/c81f424140309e4ed598fee38f0b0816.gif"
                  data-ratio="0.5735567970204841" data-w="537" /></span></section>
          </section>
        </section>
        <p class="after-image"
          style="font-size: 12px; color: #333333; line-height: 2; margin-top: 0px; margin-bottom: 0px; font-family: mp-quote, -apple-system-font, BlinkMacSystemFont, 'Helvetica Neue', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI', 'Microsoft YaHei', Arial, sans-serif;">
          <span style="font-size: 16px;"><strong><strong>顶级赛事，燃爆水族激情</strong></strong></span></p>
        <p
          style="font-size: 12px; color: #333333; line-height: 2; margin-top: 0px; margin-bottom: 0px; font-family: mp-quote, -apple-system-font, BlinkMacSystemFont, 'Helvetica Neue', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI', 'Microsoft YaHei', Arial, sans-serif;">
          <span style="font-size: 16px;">活动期间，KOL 们不仅参观了 Tetra
            生产基地，参与水族造景工作坊，还在奥斯纳布吕克动物园的水族馆中享受了一场惊喜晚宴。而其中最激动人心的环节，莫过于专业级的水族造景挑战赛。</span></p>
        <section>
          <section style="margin: 10px auto;">
            <section class="" style="border: 1px solid #28b2fe; padding: 13px; box-sizing: border-box;">
              <section class="" style="width: 100%; max-width: 100% !important; box-sizing: border-box;"><span
                  style="font-size: 16px;"><img
                    style="width: 100%; display: block; vertical-align: baseline; box-sizing: border-box; max-width: 100% !important;"
                    draggable="false"
                    src="https://xiaomeng-card-local.oss-cn-shenzhen.aliyuncs.com/local/0/0/174487809653160.png"
                    data-ratio="1" data-w="1" /></span></section>
            </section>
            <section
              style="width: 100%; height: 4px; background-color: #fea6a6; max-width: 100% !important; box-sizing: border-box;">
            </section>
            <section class="assistant"
              style="width: 60px; margin-top: -40px; margin-left: auto; margin-right: 13px; box-sizing: border-box; transform: rotateZ(0deg); -webkit-transform: rotateZ(0deg); -moz-transform: rotateZ(0deg); -o-transform: rotateZ(0deg);">
              <span style="font-size: 16px;"><img class="assistant"
                  style="width: 100%; display: block; vertical-align: baseline; box-sizing: border-box; max-width: 100% !important;"
                  draggable="false"
                  src="https://bcn.135editor.com/files/images/editor_styles/c81f424140309e4ed598fee38f0b0816.gif"
                  data-ratio="0.5735567970204841" data-w="537" /></span></section>
          </section>
        </section>
        <p class="before-image"
          style="font-size: 12px; color: #333333; line-height: 2; margin-top: 0px; margin-bottom: 0px; font-family: mp-quote, -apple-system-font, BlinkMacSystemFont, 'Helvetica Neue', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI', 'Microsoft YaHei', Arial, sans-serif;">
          <span style="font-size: 16px;">* Tetra德彩 市场与创新副总裁Casey Sims发表欢迎致辞</span></p>
        <section>
          <section style="margin: 10px auto;">
            <section class="" style="border: 1px solid #28b2fe; padding: 13px; box-sizing: border-box;">
              <section class="" style="width: 100%; max-width: 100% !important; box-sizing: border-box;"><span
                  style="font-size: 16px;"><img
                    style="width: 100%; display: block; vertical-align: baseline; box-sizing: border-box; max-width: 100% !important;"
                    draggable="false"
                    src="https://xiaomeng-card-local.oss-cn-shenzhen.aliyuncs.com/local/0/0/174487812187311.png"
                    data-ratio="1" data-w="1" /></span></section>
            </section>
            <section
              style="width: 100%; height: 4px; background-color: #fea6a6; max-width: 100% !important; box-sizing: border-box;">
            </section>
            <section class="assistant"
              style="width: 60px; margin-top: -40px; margin-left: auto; margin-right: 13px; box-sizing: border-box; transform: rotateZ(0deg); -webkit-transform: rotateZ(0deg); -moz-transform: rotateZ(0deg); -o-transform: rotateZ(0deg);">
              <span style="font-size: 16px;"><img class="assistant"
                  style="width: 100%; display: block; vertical-align: baseline; box-sizing: border-box; max-width: 100% !important;"
                  draggable="false"
                  src="https://bcn.135editor.com/files/images/editor_styles/c81f424140309e4ed598fee38f0b0816.gif"
                  data-ratio="0.5735567970204841" data-w="537" /></span></section>
          </section>
        </section>
        <section>
          <section style="margin: 10px auto;">
            <section class="" style="border: 1px solid #28b2fe; padding: 13px; box-sizing: border-box;">
              <section class="" style="width: 100%; max-width: 100% !important; box-sizing: border-box;"><span
                  style="font-size: 16px;"><img
                    style="width: 100%; display: block; vertical-align: baseline; box-sizing: border-box; max-width: 100% !important;"
                    draggable="false"
                    src="https://xiaomeng-card-local.oss-cn-shenzhen.aliyuncs.com/local/0/0/1744878164908116.png"
                    data-ratio="1" data-w="1" /></span></section>
            </section>
            <section
              style="width: 100%; height: 4px; background-color: #fea6a6; max-width: 100% !important; box-sizing: border-box;">
            </section>
            <section class="assistant"
              style="width: 60px; margin-top: -40px; margin-left: auto; margin-right: 13px; box-sizing: border-box; transform: rotateZ(0deg); -webkit-transform: rotateZ(0deg); -moz-transform: rotateZ(0deg); -o-transform: rotateZ(0deg);">
              <span style="font-size: 16px;"><img class="assistant"
                  style="width: 100%; display: block; vertical-align: baseline; box-sizing: border-box; max-width: 100% !important;"
                  draggable="false"
                  src="https://bcn.135editor.com/files/images/editor_styles/c81f424140309e4ed598fee38f0b0816.gif"
                  data-ratio="0.5735567970204841" data-w="537" /></span></section>
          </section>
        </section>
        <p
          style="font-size: 12px; color: #333333; line-height: 2; margin-top: 0px; margin-bottom: 0px; font-family: mp-quote, -apple-system-font, BlinkMacSystemFont, 'Helvetica Neue', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI', 'Microsoft YaHei', Arial, sans-serif;">
          <span style="font-size: 16px;">* Tetra 德彩生产总监Thomas Sackschewsk带领参观生产基地</span></p>

         <!-- 视频二 -->
         <div style="text-align: center;margin: 40px 0;">
          <iframe width="800" height="480" src="https://xiaomeng-card-prod.oss-cn-shenzhen.aliyuncs.com/prod/0/0/174488090036857.mp4" frameborder="0"
            allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen>
          </iframe>
        </div>
        <p
          style="font-size: 12px; color: #333333; line-height: 2; margin-top: 0px; margin-bottom: 0px; font-family: mp-quote, -apple-system-font, BlinkMacSystemFont, 'Helvetica Neue', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI', 'Microsoft YaHei', Arial, sans-serif;">
          &nbsp;</p>
        <p
          style="font-size: 12px; color: #333333; line-height: 2; margin-top: 0px; margin-bottom: 0px; font-family: mp-quote, -apple-system-font, BlinkMacSystemFont, 'Helvetica Neue', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI', 'Microsoft YaHei', Arial, sans-serif;">
          <span style="font-size: 16px;">比赛规则由知名波兰造景大师Michał Adamek
            领衔的专家评审团制定，参赛者两两组队，在五小时内以&ldquo;<strong><strong>纯粹自然（</strong></strong><strong><strong>Pure
                Nature</strong></strong><strong><strong>）</strong></strong>&rdquo;为主题，在 Tetra Starter Line 80L
            水族箱中施展才华。从锯木、破石到精雕细琢，每一支队伍都全力以赴，展现了水族造景的无限创意。Tetra食堂被临时改造成&ldquo;造景工坊&rdquo;，现场热火朝天，充满竞技氛围。</span></p>
        <section>
          <section style="margin: 10px auto;">
            <section class="" style="border: 1px solid #28b2fe; padding: 13px; box-sizing: border-box;">
              <section class="" style="width: 100%; max-width: 100% !important; box-sizing: border-box;"><span
                  style="font-size: 16px;"><img
                    style="width: 100%; display: block; vertical-align: baseline; box-sizing: border-box; max-width: 100% !important;"
                    draggable="false"
                    src="https://xiaomeng-card-local.oss-cn-shenzhen.aliyuncs.com/local/0/0/1744878181627115.png"
                    data-ratio="1" data-w="1" /></span></section>
            </section>
            <section
              style="width: 100%; height: 4px; background-color: #fea6a6; max-width: 100% !important; box-sizing: border-box;">
            </section>
            <section class="assistant"
              style="width: 60px; margin-top: -40px; margin-left: auto; margin-right: 13px; box-sizing: border-box; transform: rotateZ(0deg); -webkit-transform: rotateZ(0deg); -moz-transform: rotateZ(0deg); -o-transform: rotateZ(0deg);">
              <span style="font-size: 16px;"><img class="assistant"
                  style="width: 100%; display: block; vertical-align: baseline; box-sizing: border-box; max-width: 100% !important;"
                  draggable="false"
                  src="https://bcn.135editor.com/files/images/editor_styles/c81f424140309e4ed598fee38f0b0816.gif"
                  data-ratio="0.5735567970204841" data-w="537" /></span></section>
          </section>
        </section>
        <section>
          <section style="margin: 10px auto;">
            <section class="" style="border: 1px solid #28b2fe; padding: 13px; box-sizing: border-box;">
              <section class="" style="width: 100%; max-width: 100% !important; box-sizing: border-box;"><span
                  style="font-size: 16px;"><img
                    style="width: 100%; display: block; vertical-align: baseline; box-sizing: border-box; max-width: 100% !important;"
                    draggable="false"
                    src="https://xiaomeng-card-local.oss-cn-shenzhen.aliyuncs.com/local/0/0/1744878194555106.png"
                    data-ratio="1" data-w="1" /></span></section>
            </section>
            <section
              style="width: 100%; height: 4px; background-color: #fea6a6; max-width: 100% !important; box-sizing: border-box;">
            </section>
            <section class="assistant"
              style="width: 60px; margin-top: -40px; margin-left: auto; margin-right: 13px; box-sizing: border-box; transform: rotateZ(0deg); -webkit-transform: rotateZ(0deg); -moz-transform: rotateZ(0deg); -o-transform: rotateZ(0deg);">
              <span style="font-size: 16px;"><img class="assistant"
                  style="width: 100%; display: block; vertical-align: baseline; box-sizing: border-box; max-width: 100% !important;"
                  draggable="false"
                  src="https://bcn.135editor.com/files/images/editor_styles/c81f424140309e4ed598fee38f0b0816.gif"
                  data-ratio="0.5735567970204841" data-w="537" /></span></section>
          </section>
        </section>
        <p class="after-image"
          style="font-size: 12px; color: #333333; line-height: 2; margin-top: 0px; margin-bottom: 0px; font-family: mp-quote, -apple-system-font, BlinkMacSystemFont, 'Helvetica Neue', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI', 'Microsoft YaHei', Arial, sans-serif;">
          <span style="font-size: 16px;">*与波兰水族造景大师Michał Adamek一起的造景大师课程</span></p>
        <p
          style="font-size: 12px; color: #333333; line-height: 2; margin-top: 0px; margin-bottom: 0px; font-family: mp-quote, -apple-system-font, BlinkMacSystemFont, 'Helvetica Neue', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI', 'Microsoft YaHei', Arial, sans-serif;">
          <span
            style="font-size: 16px;">在比赛过程中，选手们首先用锯子、锤子和锉刀进行初步搭建，现场宛如繁忙的施工场地。随后，造景艺术家们利用防水胶水、镊子、刮刀和剪刀，精雕细琢每一个细节，力求在造景艺术上超越对手。</span>
        </p>
        <section>
          <section style="margin: 10px auto;">
            <section class="" style="border: 1px solid #28b2fe; padding: 13px; box-sizing: border-box;">
              <section class="" style="width: 100%; max-width: 100% !important; box-sizing: border-box;"><span
                  style="font-size: 16px;"><img
                    style="width: 100%; display: block; vertical-align: baseline; box-sizing: border-box; max-width: 100% !important;"
                    draggable="false"
                    src="https://xiaomeng-card-local.oss-cn-shenzhen.aliyuncs.com/local/0/0/1744878208846140.png"
                    data-ratio="1" data-w="1" /></span></section>
            </section>
            <section
              style="width: 100%; height: 4px; background-color: #fea6a6; max-width: 100% !important; box-sizing: border-box;">
            </section>
            <section class="assistant"
              style="width: 60px; margin-top: -40px; margin-left: auto; margin-right: 13px; box-sizing: border-box; transform: rotateZ(0deg); -webkit-transform: rotateZ(0deg); -moz-transform: rotateZ(0deg); -o-transform: rotateZ(0deg);">
              <span style="font-size: 16px;"><img class="assistant"
                  style="width: 100%; display: block; vertical-align: baseline; box-sizing: border-box; max-width: 100% !important;"
                  draggable="false"
                  src="https://bcn.135editor.com/files/images/editor_styles/c81f424140309e4ed598fee38f0b0816.gif"
                  data-ratio="0.5735567970204841" data-w="537" /></span></section>
          </section>
        </section>
        <p class="after-image"
          style="font-size: 12px; color: #333333; line-height: 2; margin-top: 0px; margin-bottom: 0px; font-family: mp-quote, -apple-system-font, BlinkMacSystemFont, 'Helvetica Neue', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI', 'Microsoft YaHei', Arial, sans-serif;">
          <span style="font-size: 16px;">*在 Tetra 德彩德国梅勒总部举办的水族造景比赛</span></p>

         <!-- 视频三 -->
         <div style="text-align: center;margin: 40px 0;">
          <iframe width="800" height="480" src="https://xiaomeng-card-prod.oss-cn-shenzhen.aliyuncs.com/prod/0/0/174488106730252.mp4" frameborder="0"
            allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen>
          </iframe>
        </div>

        <p
          style="font-size: 12px; color: #333333; line-height: 2; margin-top: 0px; margin-bottom: 0px; font-family: mp-quote, -apple-system-font, BlinkMacSystemFont, 'Helvetica Neue', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI', 'Microsoft YaHei', Arial, sans-serif;">
          &nbsp;</p>
        <p
          style="font-size: 12px; color: #333333; line-height: 2; margin-top: 0px; margin-bottom: 0px; font-family: mp-quote, -apple-system-font, BlinkMacSystemFont, 'Helvetica Neue', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI', 'Microsoft YaHei', Arial, sans-serif;">
          <span style="font-size: 16px;"><strong><strong>社交媒体助力，全球水族爱好者共襄盛举</strong></strong></span></p>
        <p
          style="font-size: 12px; color: #333333; line-height: 2; margin-top: 0px; margin-bottom: 0px; font-family: mp-quote, -apple-system-font, BlinkMacSystemFont, 'Helvetica Neue', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI', 'Microsoft YaHei', Arial, sans-serif;">
          <span style="font-size: 16px;">这不仅是一场比拼技艺的造景赛事，更是一场社交媒体的狂欢。KOL们全程拍摄、直播、互动，不断扩大活动影响力。其中，荷兰KOL
            <strong><strong>Elois Smit</strong></strong> 在 TikTok 直播了整整五小时，与法国搭档 <strong><strong>Emilie
                Bonin</strong></strong> 一起打造水族景观，收获近3
            万点赞，并感叹道：&ldquo;<strong><strong>Tetra</strong></strong><strong><strong>举办了欧洲规模最大的造景赛事，树立了全新标杆！</strong></strong>&rdquo;</span>
        </p>
        <p
          style="font-size: 12px; color: #333333; line-height: 2; margin-top: 0px; margin-bottom: 0px; font-family: mp-quote, -apple-system-font, BlinkMacSystemFont, 'Helvetica Neue', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI', 'Microsoft YaHei', Arial, sans-serif;">
          <span style="font-size: 16px;"><strong><strong>激烈角逐，冠军荣耀诞生</strong></strong></span></p>
        <p
          style="font-size: 12px; color: #333333; line-height: 2; margin-top: 0px; margin-bottom: 0px; font-family: mp-quote, -apple-system-font, BlinkMacSystemFont, 'Helvetica Neue', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI', 'Microsoft YaHei', Arial, sans-serif;">
          <span style="font-size: 16px;">比赛结束后，评审团由 <strong><strong>Michał Adamek</strong></strong> 领衔，携手来自捷克的造景专家
            <strong><strong>Jiř&iacute; Pova</strong></strong> 以及 Tetra 市场与创新副总裁 <strong><strong>Casey
                Sims</strong></strong>，对七个作品进行了严格评审。最终，西班牙团队的作品凭借其纯粹自然的设计理念与卓越工艺，赢得最高荣誉。</span></p>
        <section>
          <section style="margin: 10px auto;">
            <section class="" style="border: 1px solid #28b2fe; padding: 13px; box-sizing: border-box;">
              <section class="" style="width: 100%; max-width: 100% !important; box-sizing: border-box;"><span
                  style="font-size: 16px;"><img
                    style="width: 100%; display: block; vertical-align: baseline; box-sizing: border-box; max-width: 100% !important;"
                    draggable="false"
                    src="https://xiaomeng-card-local.oss-cn-shenzhen.aliyuncs.com/local/0/0/174487824985095.png"
                    data-ratio="1" data-w="1" /></span></section>
            </section>
            <section
              style="width: 100%; height: 4px; background-color: #fea6a6; max-width: 100% !important; box-sizing: border-box;">
            </section>
            <section class="assistant"
              style="width: 60px; margin-top: -40px; margin-left: auto; margin-right: 13px; box-sizing: border-box; transform: rotateZ(0deg); -webkit-transform: rotateZ(0deg); -moz-transform: rotateZ(0deg); -o-transform: rotateZ(0deg);">
              <span style="font-size: 16px;"><img class="assistant"
                  style="width: 100%; display: block; vertical-align: baseline; box-sizing: border-box; max-width: 100% !important;"
                  draggable="false"
                  src="https://bcn.135editor.com/files/images/editor_styles/c81f424140309e4ed598fee38f0b0816.gif"
                  data-ratio="0.5735567970204841" data-w="537" /></span></section>
          </section>
        </section>
        <p class="after-image"
          style="font-size: 12px; color: #333333; line-height: 2; margin-top: 0px; margin-bottom: 0px; font-family: mp-quote, -apple-system-font, BlinkMacSystemFont, 'Helvetica Neue', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI', 'Microsoft YaHei', Arial, sans-serif;">
          <span style="font-size: 16px;">*三位评审点评中</span></p>
        <p
          style="font-size: 12px; color: #333333; line-height: 2; margin-top: 0px; margin-bottom: 0px; font-family: mp-quote, -apple-system-font, BlinkMacSystemFont, 'Helvetica Neue', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI', 'Microsoft YaHei', Arial, sans-serif;">
          &nbsp;</p>
        <p
          style="font-size: 12px; color: #333333; line-height: 2; margin-top: 0px; margin-bottom: 0px; font-family: mp-quote, -apple-system-font, BlinkMacSystemFont, 'Helvetica Neue', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI', 'Microsoft YaHei', Arial, sans-serif;">
          <span style="font-size: 16px;">最终，三支队伍凭借卓越作品脱颖而出：</span></p>
        <p
          style="font-size: 12px; color: #333333; line-height: 2; margin-top: 0px; margin-bottom: 0px; font-family: mp-quote, -apple-system-font, BlinkMacSystemFont, 'Helvetica Neue', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI', 'Microsoft YaHei', Arial, sans-serif;">
          <span style="font-size: 16px;"><strong><strong>季军</strong></strong></span></p>
        <p class="before-image"
          style="font-size: 12px; color: #333333; line-height: 2; margin-top: 0px; margin-bottom: 0px; font-family: mp-quote, -apple-system-font, BlinkMacSystemFont, 'Helvetica Neue', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI', 'Microsoft YaHei', Arial, sans-serif;">
          <span style="font-size: 16px;">德国选手 <strong><strong>Sascha Hoyer</strong></strong> 与意大利选手
            <strong><strong>Alberto Farinello</strong></strong>，奖金&euro;500。</span></p>
        <section>
          <section style="margin: 10px auto;">
            <section class="" style="border: 1px solid #28b2fe; padding: 13px; box-sizing: border-box;">
              <section class="" style="width: 100%; max-width: 100% !important; box-sizing: border-box;"><span
                  style="font-size: 16px;"><img
                    style="width: 100%; display: block; vertical-align: baseline; box-sizing: border-box; max-width: 100% !important;"
                    draggable="false"
                    src="https://xiaomeng-card-local.oss-cn-shenzhen.aliyuncs.com/local/0/0/174487827762167.png"
                    data-ratio="1" data-w="1" /></span></section>
            </section>
            <section
              style="width: 100%; height: 4px; background-color: #fea6a6; max-width: 100% !important; box-sizing: border-box;">
            </section>
            <section class="assistant"
              style="width: 60px; margin-top: -40px; margin-left: auto; margin-right: 13px; box-sizing: border-box; transform: rotateZ(0deg); -webkit-transform: rotateZ(0deg); -moz-transform: rotateZ(0deg); -o-transform: rotateZ(0deg);">
              <span style="font-size: 16px;"><img class="assistant"
                  style="width: 100%; display: block; vertical-align: baseline; box-sizing: border-box; max-width: 100% !important;"
                  draggable="false"
                  src="https://bcn.135editor.com/files/images/editor_styles/c81f424140309e4ed598fee38f0b0816.gif"
                  data-ratio="0.5735567970204841" data-w="537" /></span></section>
          </section>
        </section>
        <p class="after-image"
          style="font-size: 12px; color: #333333; line-height: 2; margin-top: 0px; margin-bottom: 0px; font-family: mp-quote, -apple-system-font, BlinkMacSystemFont, 'Helvetica Neue', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI', 'Microsoft YaHei', Arial, sans-serif;">
          <span style="font-size: 16px;"><strong><strong>亚军</strong></strong></span></p>
        <p class="before-image"
          style="font-size: 12px; color: #333333; line-height: 2; margin-top: 0px; margin-bottom: 0px; font-family: mp-quote, -apple-system-font, BlinkMacSystemFont, 'Helvetica Neue', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI', 'Microsoft YaHei', Arial, sans-serif;">
          <span style="font-size: 16px;">荷兰与法国女子组合 ，奖金 &euro;1,000</span></p>
        <section>
          <section style="margin: 10px auto;">
            <section class="" style="border: 1px solid #28b2fe; padding: 13px; box-sizing: border-box;">
              <section class="" style="width: 100%; max-width: 100% !important; box-sizing: border-box;"><span
                  style="font-size: 16px;"><img
                    style="width: 100%; display: block; vertical-align: baseline; box-sizing: border-box; max-width: 100% !important;"
                    draggable="false"
                    src="https://xiaomeng-card-local.oss-cn-shenzhen.aliyuncs.com/local/0/0/174487836513281.png"
                    data-ratio="1" data-w="1" /></span></section>
            </section>
            <section
              style="width: 100%; height: 4px; background-color: #fea6a6; max-width: 100% !important; box-sizing: border-box;">
            </section>
            <section class="assistant"
              style="width: 60px; margin-top: -40px; margin-left: auto; margin-right: 13px; box-sizing: border-box; transform: rotateZ(0deg); -webkit-transform: rotateZ(0deg); -moz-transform: rotateZ(0deg); -o-transform: rotateZ(0deg);">
              <span style="font-size: 16px;"><img class="assistant"
                  style="width: 100%; display: block; vertical-align: baseline; box-sizing: border-box; max-width: 100% !important;"
                  draggable="false"
                  src="https://bcn.135editor.com/files/images/editor_styles/c81f424140309e4ed598fee38f0b0816.gif"
                  data-ratio="0.5735567970204841" data-w="537" /></span></section>
          </section>
        </section>
        <p class="after-image"
          style="font-size: 12px; color: #333333; line-height: 2; margin-top: 0px; margin-bottom: 0px; font-family: mp-quote, -apple-system-font, BlinkMacSystemFont, 'Helvetica Neue', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI', 'Microsoft YaHei', Arial, sans-serif;">
          <span style="font-size: 16px;"><strong><strong>冠军</strong></strong></span></p>
        <p
          style="font-size: 12px; color: #333333; line-height: 2; margin-top: 0px; margin-bottom: 0px; font-family: mp-quote, -apple-system-font, BlinkMacSystemFont, 'Helvetica Neue', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI', 'Microsoft YaHei', Arial, sans-serif;">
          <span style="font-size: 16px;">西班牙团队 <strong><strong>Ismael Aguilar Soria &amp; Jes&uacute;s Olier
                P&eacute;rez</strong></strong>，</span></p>
        <p class="before-image"
          style="font-size: 12px; color: #333333; line-height: 2; margin-top: 0px; margin-bottom: 0px; font-family: mp-quote, -apple-system-font, BlinkMacSystemFont, 'Helvetica Neue', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI', 'Microsoft YaHei', Arial, sans-serif;">
          <span style="font-size: 16px;">凭借对&ldquo;纯粹自然&rdquo;的完美诠释斩获奖金&euro;2,000</span></p>
        <section>
          <section style="margin: 10px auto;">
            <section class="" style="border: 1px solid #28b2fe; padding: 13px; box-sizing: border-box;">
              <section class="" style="width: 100%; max-width: 100% !important; box-sizing: border-box;"><span
                  style="font-size: 16px;"><img
                    style="width: 100%; display: block; vertical-align: baseline; box-sizing: border-box; max-width: 100% !important;"
                    draggable="false"
                    src="https://xiaomeng-card-local.oss-cn-shenzhen.aliyuncs.com/local/0/0/174487840874964.png"
                    data-ratio="1" data-w="1" /></span></section>
            </section>
            <section
              style="width: 100%; height: 4px; background-color: #fea6a6; max-width: 100% !important; box-sizing: border-box;">
            </section>
            <section class="assistant"
              style="width: 60px; margin-top: -40px; margin-left: auto; margin-right: 13px; box-sizing: border-box; transform: rotateZ(0deg); -webkit-transform: rotateZ(0deg); -moz-transform: rotateZ(0deg); -o-transform: rotateZ(0deg);">
              <span style="font-size: 16px;"><img class="assistant"
                  style="width: 100%; display: block; vertical-align: baseline; box-sizing: border-box; max-width: 100% !important;"
                  draggable="false"
                  src="https://bcn.135editor.com/files/images/editor_styles/c81f424140309e4ed598fee38f0b0816.gif"
                  data-ratio="0.5735567970204841" data-w="537" /></span></section>
          </section>
        </section>
        <section>
          <section style="margin: 10px auto;">
            <section class="" style="border: 1px solid #28b2fe; padding: 13px; box-sizing: border-box;">
              <section class="" style="width: 100%; max-width: 100% !important; box-sizing: border-box;"><span
                  style="font-size: 16px;"><img
                    style="width: 100%; display: block; vertical-align: baseline; box-sizing: border-box; max-width: 100% !important;"
                    draggable="false"
                    src="https://xiaomeng-card-local.oss-cn-shenzhen.aliyuncs.com/local/0/0/174487842570658.png"
                    data-ratio="1" data-w="1" /></span></section>
            </section>
            <section
              style="width: 100%; height: 4px; background-color: #fea6a6; max-width: 100% !important; box-sizing: border-box;">
            </section>
            <section class="assistant"
              style="width: 60px; margin-top: -40px; margin-left: auto; margin-right: 13px; box-sizing: border-box; transform: rotateZ(0deg); -webkit-transform: rotateZ(0deg); -moz-transform: rotateZ(0deg); -o-transform: rotateZ(0deg);">
              <span style="font-size: 16px;"><img class="assistant"
                  style="width: 100%; display: block; vertical-align: baseline; box-sizing: border-box; max-width: 100% !important;"
                  draggable="false"
                  src="https://bcn.135editor.com/files/images/editor_styles/c81f424140309e4ed598fee38f0b0816.gif"
                  data-ratio="0.5735567970204841" data-w="537" /></span></section>
          </section>
        </section>
        <section>
          <section style="margin: 10px auto;">
            <section class="" style="border: 1px solid #28b2fe; padding: 13px; box-sizing: border-box;">
              <section class="" style="width: 100%; max-width: 100% !important; box-sizing: border-box;"><span
                  style="font-size: 16px;"><img
                    style="width: 100%; display: block; vertical-align: baseline; box-sizing: border-box; max-width: 100% !important;"
                    draggable="false"
                    src="https://xiaomeng-card-local.oss-cn-shenzhen.aliyuncs.com/local/0/0/174487844426783.png"
                    data-ratio="1" data-w="1" /></span></section>
            </section>
            <section
              style="width: 100%; height: 4px; background-color: #fea6a6; max-width: 100% !important; box-sizing: border-box;">
            </section>
            <section class="assistant"
              style="width: 60px; margin-top: -40px; margin-left: auto; margin-right: 13px; box-sizing: border-box; transform: rotateZ(0deg); -webkit-transform: rotateZ(0deg); -moz-transform: rotateZ(0deg); -o-transform: rotateZ(0deg);">
              <span style="font-size: 16px;"><img class="assistant"
                  style="width: 100%; display: block; vertical-align: baseline; box-sizing: border-box; max-width: 100% !important;"
                  draggable="false"
                  src="https://bcn.135editor.com/files/images/editor_styles/c81f424140309e4ed598fee38f0b0816.gif"
                  data-ratio="0.5735567970204841" data-w="537" /></span></section>
          </section>
        </section>
        <p class="after-image"
          style="font-size: 12px; color: #333333; line-height: 2; margin-top: 0px; margin-bottom: 0px; font-family: mp-quote, -apple-system-font, BlinkMacSystemFont, 'Helvetica Neue', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI', 'Microsoft YaHei', Arial, sans-serif;">
          <span style="font-size: 16px;">*水族造景比赛前三名获奖团队</span></p>
        <p
          style="font-size: 12px; color: #333333; line-height: 2; margin-top: 0px; margin-bottom: 0px; font-family: mp-quote, -apple-system-font, BlinkMacSystemFont, 'Helvetica Neue', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI', 'Microsoft YaHei', Arial, sans-serif;">
          &nbsp;</p>
        <p
          style="font-size: 12px; color: #333333; line-height: 2; margin-top: 0px; margin-bottom: 0px; font-family: mp-quote, -apple-system-font, BlinkMacSystemFont, 'Helvetica Neue', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI', 'Microsoft YaHei', Arial, sans-serif;">
          <span style="font-size: 16px;">Tetra 德彩水族品牌总监 <strong><strong>Janina Garving</strong></strong>
            在颁奖典礼上表示：&ldquo;<strong><strong>2025 Aquatics Festival
              </strong></strong><strong><strong>很可能成为</strong></strong><strong><strong> Tetra
              </strong></strong><strong><strong>的新传统。更重要的是，这仅仅是个开始！</strong></strong>&rdquo; 未来，Tetra
            将推出更多专为水族造景玩家及水族新手打造的创新产品，助力全球水族爱好者探索更多可能。</span></p>
        <section>
          <section style="margin: 10px auto;">
            <section class="" style="border: 1px solid #28b2fe; padding: 13px; box-sizing: border-box;">
              <section class="" style="width: 100%; max-width: 100% !important; box-sizing: border-box;"><span
                  style="font-size: 16px;"><img
                    style="width: 100%; display: block; vertical-align: baseline; box-sizing: border-box; max-width: 100% !important;"
                    draggable="false"
                    src="https://xiaomeng-card-local.oss-cn-shenzhen.aliyuncs.com/local/0/0/174487846146070.png"
                    data-ratio="1" data-w="1" /></span></section>
            </section>
            <section
              style="width: 100%; height: 4px; background-color: #fea6a6; max-width: 100% !important; box-sizing: border-box;">
            </section>
            <section class="assistant"
              style="width: 60px; margin-top: -40px; margin-left: auto; margin-right: 13px; box-sizing: border-box; transform: rotateZ(0deg); -webkit-transform: rotateZ(0deg); -moz-transform: rotateZ(0deg); -o-transform: rotateZ(0deg);">
              <span style="font-size: 16px;"><img class="assistant"
                  style="width: 100%; display: block; vertical-align: baseline; box-sizing: border-box; max-width: 100% !important;"
                  draggable="false"
                  src="https://bcn.135editor.com/files/images/editor_styles/c81f424140309e4ed598fee38f0b0816.gif"
                  data-ratio="0.5735567970204841" data-w="537" /></span></section>
          </section>
        </section>
        <p class="after-image"
          style="font-size: 12px; color: #333333; line-height: 2; margin-top: 0px; margin-bottom: 0px; font-family: mp-quote, -apple-system-font, BlinkMacSystemFont, 'Helvetica Neue', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI', 'Microsoft YaHei', Arial, sans-serif;">
          <span style="font-size: 16px;"><strong><strong>水族的世界，远不止于此</strong><strong>&mdash;&mdash;Much more is
                possible!</strong></strong></span></p>
        <p
          style="font-size: 12px; color: #333333; line-height: 2; margin-top: 0px; margin-bottom: 0px; font-family: mp-quote, -apple-system-font, BlinkMacSystemFont, 'Helvetica Neue', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei UI', 'Microsoft YaHei', Arial, sans-serif;">
          &nbsp;</p>
      </div>

    </div>

    <!-- 底部 -->
    <foot />

  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
.d-flex {
  display: flex;
}

.a-center {
  align-items: center;
}

.j-sb {
  justify-content: space-between;
}

.j-center {
  justify-content: center;
}

.container {
  width: 1000px;
  margin: 0 auto;

  .title {
    font-size: 28px;
    font-weight: 600;
    color: #333;
    margin-bottom: 30px !important;
  }
}
</style>